import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import global from "@/utils/global.js";
import Snotify, { SnotifyPosition } from "vue-snotify";
import VueSlideoutPanel from "vue2-slideout-panel";
//import VueYouTubeEmbed from "vue-youtube-embed";
//import Sortable from "vue-sortable";
//import VuetifyNumberInput from "@jzolago/vuetify-number-input";
import "@/assets/brand.scss";
import "@/assets/custom.scss";
import "vue-snotify/styles/material.css";
import "@/assets/style-new.scss";
import "@/assets/responsive.scss";
import vueKanban from "vue-kanban";
import VueMeta from 'vue-meta';
import { applyStoredConsent } from "@/utils/trackers";
window.$ = window.jQuery = require('jquery');

Vue.config.productionTip = false
Vue.prototype.$gf = global;

const options = {
  toast: {
    position: SnotifyPosition.centerTop
  }
};

Vue.router = router;

Vue.use(Snotify, options);
Vue.use(VueSlideoutPanel);
Vue.use(vueKanban);
Vue.use(VueMeta);

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')

// Re-apply the visitor's stored cookie choice on every load, so anything they
// previously accepted is loaded and anything they declined stays off.
applyStoredConsent();
